import { checkEnableParseJSON, formatBoolean } from 'components/helper/helper';
import moment from 'moment';

type Props = {
  data: any;
};

const CLEPSum = (props: Props) => {
  const data = checkEnableParseJSON(props.data, []);
  
  return Array.isArray(data) ? (
    <div className="gm-summary-table-section">
      <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
        CLEP Test Scores
      </div>
      <div className="gm-summary-list">
        {(data ?? []).map((item: any, index: number) => (
          <div key={index} className="gm-summary-list-item">
            <div className="gm-summary-text-dark">
              {[
                moment(item?.date_taken).format('MM-DD-YYYY'),
                item?.CLEPExam,
                `Score: ${item?.score}`,
              ].join(' - ')}
            </div>
            <div className="gm-summary-checkbox-container">
              <span style={{
                marginRight: '12px',
                fontSize: '18px',
                color: formatBoolean(item?.is_not_received) ? '#1890ff' : '#d9d9d9',
                fontWeight: formatBoolean(item?.is_not_received) ? 'bold' : 'normal',
              }}>
                {formatBoolean(item?.is_not_received) ? '✓' : '○'}
              </span>
              Score Not Yet Received
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default CLEPSum;
